module.exports = __webpack_public_path__ + "static/media/socialMediaNews4.4e96c089.svg";